import {ComponentFactoryResolver, Injectable, Renderer2, RendererFactory2} from '@angular/core';
import {TableComponent} from '../table.component';

@Injectable()
export class TableSelectionService {

  public lastSelectedOrUnselectedEntity: any = null;
  public isHeaderCheckboxChecked = false;
  public isHeaderCheckboxCheckedByUser = false;
  public selection: any[] = [];

  private table: TableComponent = null;

  private renderer: Renderer2;

  public constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  public addOrRemove(entity: object): this {

    if (this.isSelected(entity)) {
      this.remove(entity);
    } else {
      this.add(entity);
    }

    return this;
  }

  public selectFirst(): this {
    const entity = this.table.tableEntities[0];

    if (entity) {
      this.add(entity);
      this.lastSelectedOrUnselectedEntity = entity;
      this.table.currentlySelectedEntity = entity;
    }

    return this;
  }

  public add(entity: object): this {
    const exists = this.isSelected(entity);

    this.lastSelectedOrUnselectedEntity = entity;

    if (!exists) {
      this.selection = [...this.selection, entity];
    }

    this.checkAllSelected();

    return this;
  }

  public remove(entity: object): this {
    const index = this.entityIndex(entity);

    this.lastSelectedOrUnselectedEntity = entity;

    this.isHeaderCheckboxCheckedByUser = false;

    if (index !== -1) {
      this.selection.splice(index, 1);
    }

    this.checkAllSelected();

    this.removeHighlight();

    return this;
  }

  public onEntitiesChange(): this {

    if (this.isHeaderCheckboxCheckedByUser) {
      this.selectAll();
    } else {
      this.checkAllSelected();
    }

    return this;
  }

  public selectAll(): this {

    for (const entity of this.table.tableEntities) {
      this.add(entity);
    }

    return this;
  }

  public removeAll(): this {
    this.selection = [];
    this.isHeaderCheckboxChecked = false;
    this.isHeaderCheckboxCheckedByUser = false;
    this.table.currentlySelectedEntity = null;

    this.removeHighlight();

    return this;
  }

  public isSelected(entity): boolean {
    return this.entityIndex(entity) !== -1;
  }

  public setTable(table: TableComponent): this {
    this.table = table;
    return this;
  }

  public getTable(): TableComponent|null {
    return this.table;
  }

  public entityIndex(entity): number {
    const index = this.selection.findIndex((aEntity) => entity.id === aEntity.id);

    if (entity.uniqueId) {
      return this.selection.findIndex((aEntity) => entity.uniqueId === aEntity.uniqueId);
    }

    return index;
  }

  private checkAllSelected(): this {
    this.isHeaderCheckboxChecked = this.isHeaderCheckboxCheckedByUser;

    return this;
  }

  private removeHighlight() {
    const selectedDataTableTrNodes: NodeList = this.table.dataTable.el.nativeElement.querySelectorAll('tr.ui-state-highlight');

    for (let i = 0; i < selectedDataTableTrNodes.length; i++) {
      const tr = selectedDataTableTrNodes[i];
      this.renderer.removeClass(tr, 'ui-state-highlight');
    }
  }
}
